import React from 'react';
import { formatDate } from '../utils';

const ICTSupportSection = ({ ticket }) => {
  return (
    <div className="mb-6 p-6 rounded-xl border border-cyan-500/20 shadow-lg relative bg-gradient-to-br from-cyan-50 to-cyan-100 before:content-[''] before:absolute before:top-0 before:left-0 before:w-1 before:h-full before:bg-gradient-to-b before:from-cyan-600 before:to-cyan-500 before:rounded-l-sm">
      <h3 className="text-slate-900 font-bold mb-4 font-poppins flex items-center gap-3 text-xl">
        🛠️ ICT Support Information
      </h3>
      <div className="grid grid-cols-1 gap-4">
        <div className="col-span-1">
          <div className="p-4 bg-white rounded-lg border border-cyan-500/15 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
            <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-cyan-700">
              👨‍💻 Assigned To
            </p>
            <p className="font-semibold font-poppins text-slate-900 text-base flex items-center gap-2">
              <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
              </svg>
              {ticket.ictAssignedTo || 'Not yet assigned'}
            </p>
          </div>
        </div>
        
        {ticket.ictDiagnosisDetails && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-cyan-500/15 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-cyan-700">
                🔍 Diagnosis
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base leading-relaxed">
                {ticket.ictDiagnosisDetails}
              </p>
            </div>
          </div>
        )}
        
        {ticket.ictFixDetails && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-cyan-500/15 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-cyan-700">
                🔧 Fix Details
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base leading-relaxed">
                {ticket.ictFixDetails}
              </p>
            </div>
          </div>
        )}
        
        {ticket.ictDateFixed && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-cyan-500/15 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-cyan-700">
                📅 Date Fixed
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base">
                {formatDate(ticket.ictDateFixed)}
              </p>
            </div>
          </div>
        )}
        
        {ticket.ictRecommendations && (
          <div className="col-span-1">
            <div className="p-4 bg-white rounded-lg border border-cyan-500/15 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
              <p className="font-poppins font-semibold text-xs uppercase tracking-wider mb-2 text-cyan-700">
                💡 Recommendations
              </p>
              <p className="font-semibold font-poppins text-slate-900 text-base leading-relaxed">
                {ticket.ictRecommendations}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ICTSupportSection;